if (!customElements.get('product-card-video')) {
  class ProductCardVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.initialized) return;

      this.initialized = true;
      this.mode = this.dataset.mode || 'primary';
      this.hoverTarget = this.closest('.image-cont');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.saveData = Boolean(navigator.connection && navigator.connection.saveData);
      this.hasFineHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.mobileAutoplay = this.dataset.mobileAutoplay === 'true';

      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.playsInline = true;

      this.onVideoError = () => this.classList.add('product-card-video--failed');
      this.video.addEventListener('error', this.onVideoError);

      if (this.reducedMotion || this.saveData) {
        this.classList.add('product-card-video--disabled');
        return;
      }

      if (this.mode === 'hover') {
        this.setupHoverVideo();
      } else {
        this.setupPrimaryVideo();
      }
    }

    setupPrimaryVideo() {
      if (!this.hasFineHover && !this.mobileAutoplay) {
        this.classList.add('product-card-video--disabled');
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry && entry.isIntersecting && entry.intersectionRatio >= 0.35 && !document.hidden) {
          this.play();
        } else {
          this.pause();
        }
      }, { threshold: [0, 0.35, 0.75] });

      this.observer.observe(this);
      this.onVisibilityChange = () => document.hidden ? this.pause() : null;
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    setupHoverVideo() {
      if (!this.hasFineHover || !this.hoverTarget) return;

      this.onPointerEnter = () => this.play();
      this.onPointerLeave = () => this.pause(true);
      this.onFocusIn = () => this.play();
      this.onFocusOut = () => this.pause(true);

      this.hoverTarget.addEventListener('pointerenter', this.onPointerEnter);
      this.hoverTarget.addEventListener('pointerleave', this.onPointerLeave);
      this.hoverTarget.addEventListener('focusin', this.onFocusIn);
      this.hoverTarget.addEventListener('focusout', this.onFocusOut);
    }

    play() {
      const promise = this.video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(() => {});
    }

    pause(reset = false) {
      if (!this.video) return;
      this.video.pause();
      if (reset) {
        try { this.video.currentTime = 0; } catch (error) {}
      }
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.pause();
      this.observer?.disconnect();
      this.video?.removeEventListener('error', this.onVideoError);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.hoverTarget?.removeEventListener('pointerenter', this.onPointerEnter);
      this.hoverTarget?.removeEventListener('pointerleave', this.onPointerLeave);
      this.hoverTarget?.removeEventListener('focusin', this.onFocusIn);
      this.hoverTarget?.removeEventListener('focusout', this.onFocusOut);
      this.initialized = false;
    }
  }

  customElements.define('product-card-video', ProductCardVideo);
}
